import type { PerformanceKpiCatalogEntry, PerformanceKpiId } from "./my-brand-drawer-performance-catalog"
import { MY_BRAND_DRAWER_PERFORMANCE_CATALOG } from "./my-brand-drawer-performance-catalog"

const EXCLUDED_FATIGUE_IDS = new Set<PerformanceKpiId>(["spendPct", "creativesPct"])

/** v1 chartable KPIs — Performance catalog minus Spend % / Creatives %. */
export const MY_BRAND_DRAWER_FATIGUE_CATALOG: PerformanceKpiCatalogEntry[] =
  MY_BRAND_DRAWER_PERFORMANCE_CATALOG.filter((e) => !EXCLUDED_FATIGUE_IDS.has(e.id))

export const MAX_FATIGUE_KPI_SELECTION = 6

export type FatigueGranularity = "daily" | "weekly" | "monthly"

/** Longest window with too few whole months in it for a monthly bucket to say anything. */
const MONTHLY_GRANULARITY_MIN_SPAN_DAYS = 31

/**
 * Judged on the selected window rather than the lookback token, so a custom range gets the
 * same treatment as a preset of the same length. The `7d` and `30d` tokens resolve to spans
 * of 7 and 30 days, so both keep monthly disabled.
 */
export function isMonthlyGranularityDisabled(spanDays: number): boolean {
  return spanDays <= MONTHLY_GRANULARITY_MIN_SPAN_DAYS
}
